/* unplugin-vue-components disabled */import script from "./RightToolBar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightToolBar.vue?vue&type=script&setup=true&lang=js"

import "./RightToolBar.vue?vue&type=style&index=0&id=2bba9e18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bba9e18"]])

export default __exports__